'use client';

import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

export default function FadeIn({
  children,
  delay = 0,
  className = '',
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  // Always render the same element. Branching on useReducedMotion() made the
  // server HTML (motion.div at opacity 0) differ from the reduced-motion
  // client render, and hydration kept the server's opacity 0, so these
  // sections stayed blank for reduced-motion visitors. The fade-in class lets
  // globals.css force them visible under prefers-reduced-motion.
  const shouldReduce = useReducedMotion();

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={shouldReduce ? { duration: 0 } : { duration: 0.5, delay, ease: 'easeOut' }}
      className={`fade-in ${className}`}
    >
      {children}
    </motion.div>
  );
}
